import { createComponent } from '../lib';
import { VmScrubberControl, VmSlider, VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-scrubber-control', VmScrubberControl);
define('vm-slider', VmSlider);
define('vm-tooltip', VmTooltip);
;
export default createComponent('vm-scrubber-control', new Set(['alwaysShowHours', 'hideTooltip', 'currentTime', 'duration', 'noKeyboard', 'buffering', 'buffered', 'i18n']));
